export default "/images/vendor/flag-icons/flags/4x3/br.svg?33b38c329c8eb7d5a36608c1c5afa492";